import { createFileRoute, redirect } from '@tanstack/react-router'
import { ReturnFormScreen } from '@/features/sales-returns/return-form-screen'
import { hasGrant } from '@/lib/me'

/**
 * The return form is reached from a confirmed sales order (plan screen 6
 * names no route for it): an `orderId` search param carries which order is
 * being reversed, set by the "New return" action on
 * `order-returns-panel.tsx`. A direct visit with no `orderId` has nothing to
 * reverse, so it bounces to the return list rather than rendering a form with
 * no lines (mirrors `_authenticated/purchasing/returns.new.tsx`).
 */
export const Route = createFileRoute('/_authenticated/sales/returns/new')({
  validateSearch: (search: Record<string, unknown>): { orderId: string } => ({
    orderId: typeof search.orderId === 'string' ? search.orderId : '',
  }),
  beforeLoad: ({ context, search }) => {
    if (!hasGrant(context.queryClient, 'customer_return.create')) {
      throw redirect({ to: '/sales/returns' })
    }
    if (!search.orderId) {
      throw redirect({ to: '/sales/orders' })
    }
  },
  component: CustomerReturnNewRoute,
})

function CustomerReturnNewRoute() {
  const { orderId } = Route.useSearch()

  return <ReturnFormScreen orderId={orderId} />
}
